<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <template v-for="item in leftMenu">
      <div :key="'title' + item.subMenuTitle" class="side-bar-title" >{{ item.subMenuTitle }}</div>
      <el-menu
        :key="item.subMenuTitle"
        :default-active="$route.path"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        mode="vertical"
      >
        <sidebar-item v-for="route in item.subMenu" :key="route.path" :item="route" :base-path="route.path"/>
      </el-menu>
    </template>

  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem },
  props: {
    routeMenu: {
      type: Array,
      default: () => {
        return []
      }
    },
    leftMenu: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    variables () {
      return variables
    },
    isCollapse () {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss" scoped>
  .side-bar-title {
    margin: 0 20px;
    padding: 16px 0 6px;
    border-top: 1px solid #ececec;
    &:first-child{
      padding-top: 20px;
      border-top : 0;
    }
    /*border-top: solid 4px rgba(85, 118, 207, 1);*/
    /*border-bottom: solid 1px #e5e5e5;*/
    background-color: #fff;
    font-size: 16px;
    font-weight: 600;
    color: #4a4a4a;

  }

</style>
